function unregister() {
	navigator.serviceWorker?.getRegistrations().then(function (registrations) {
		for (const registration of registrations) {
			registration.unregister();
		}
	});
}

export { unregister };
